if (!customElements.get('chat-widget')) {
  customElements.define(
    'chat-widget',
    class ChatWidget extends HTMLElement {
      constructor() {
        super();
        this.toggleButton = this.querySelector('.chat-widget__toggle');
        this.onDocumentClick = this.onDocumentClick.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

        this.toggleButton.addEventListener('click', () => this.toggle());
        this.querySelector('.chat-widget__list').addEventListener('click', (event) => {
          if (event.target.closest('a')) this.toggle(false);
        });
      }

      connectedCallback() {
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keyup', this.onKeyUp);
        this.observeFooter();
      }

      disconnectedCallback() {
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keyup', this.onKeyUp);
        if (this.footerObserver) this.footerObserver.disconnect();
      }

      toggle(force) {
        const open = typeof force === 'boolean' ? force : !this.classList.contains('is-open');
        this.classList.toggle('is-open', open);
        this.toggleButton.setAttribute('aria-expanded', open);
      }

      onDocumentClick(event) {
        if (!this.contains(event.target)) this.toggle(false);
      }

      onKeyUp(event) {
        if (event.code !== 'Escape' || !this.classList.contains('is-open')) return;
        const hadFocus = this.contains(document.activeElement);
        this.toggle(false);
        if (hadFocus) this.toggleButton.focus();
      }

      observeFooter() {
        const footer = document.querySelector('.footer');
        if (!footer || !('IntersectionObserver' in window)) return;

        this.footerObserver = new IntersectionObserver(
          ([entry]) => {
            this.classList.toggle('is-footer-visible', entry.isIntersecting);
            if (entry.isIntersecting && window.matchMedia('(max-width: 1199.98px)').matches) this.toggle(false);
          },
          { threshold: 0.1 }
        );
        this.footerObserver.observe(footer);
      }
    }
  );
}
